import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { URL_MAP } from '../../shared/urlMap';

export interface FirmaSesionResponse {
  idEnlaceFirma: number;
  idSolicitudesRadicadas: number;
  fechaExpiracion: string;
  estado: string;
  firmado: boolean;
}

export interface DocumentoFirmaItem {
  idDocSoporte: number;
  rutaArchivo: string;
  cargada: string;
  codigoDocumento: string;
  nombreDocumento: string;
  idTipoDocumento: number;
}

export interface IntegranteFirmaItem {
  id: number;
  tipoDocumento: string;
  nroDocumento: string;
  nombreUsuario: string;
  parentesco: string;
  correo: string;
  celular: string;
  documentos: DocumentoFirmaItem[];
}

export interface FirmaSolicitudResponse {
  idSolicitudesRadicadas: number;
  nroSolicitudTraslado: number;
  fechaCreacion: string;
  idTipoNovedad?: number;
  tipoNovedad: string;
  idTipoSolicitud?: number;
  tipoSolicitud?: string;
  contratante: IntegranteFirmaItem;
  integrantes: IntegranteFirmaItem[];
}

export interface FirmaEjecutarRequest {
  idEnlaceFirma: number;
  idSolicitudesRadicadas: number;
  codigoOtp: string;
  datosNavegador: string;
  sistemaOperativo: string;
  fechaAccesoEnlace: string;
}

export interface FirmaEjecutarResponse {
  codigoRespuesta: number;
  mensaje: string;
  idTransaccion: string;
  fechaFirma: string;
}

export interface EnlaceFirmaResponse {
  idEnlaceFirma: number;
  idSolicitudesRadicadas: number;
  enlaceCorto: string;
  enlaceCompleto: string;
  fechaGeneracion: string;
  fechaExpiracion: string;
  estado: string;
}

@Injectable({
  providedIn: 'root',
})
export class FirmaService {
  private readonly baseUrl = environment.HOST;

  constructor(private http: HttpClient) {}

  validarSesion(token: string): Observable<FirmaSesionResponse> {
    return this.http.get<FirmaSesionResponse>(
      `${this.baseUrl}${URL_MAP.API.FIRMA_SESION}`,
      { params: { token } },
    );
  }

  obtenerDatosSolicitud(token: string): Observable<FirmaSolicitudResponse> {
    return this.http.get<FirmaSolicitudResponse>(
      `${this.baseUrl}${URL_MAP.API.FIRMA_SOLICITUD}`,
      { params: { token } },
    );
  }

  ejecutarFirma(
    request: FirmaEjecutarRequest,
  ): Observable<FirmaEjecutarResponse> {
    return this.http.post<FirmaEjecutarResponse>(
      `${this.baseUrl}${URL_MAP.API.FIRMA_EJECUTAR}`,
      request,
    );
  }

  generarEnlace(idSolicitud: number): Observable<EnlaceFirmaResponse> {
    return this.http.post<EnlaceFirmaResponse>(
      `${this.baseUrl}${URL_MAP.API.FIRMA_ENLACE}/${idSolicitud}`,
      {},
    );
  }
}
